import { Orientation, useOrientation } from "hooks/orientation";
import { Size, useWindowSize } from "hooks/windowSize";
import { Values } from "Interfaces/IParameters";
import Layout from "Layout";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { configApp } from "utils";
import FilterComponent from "Views/SSRS/Components/FilterComponent";
import {
  AnimationContainer,
  Head,
  IframeContainer,
} from "Views/SSRS/styled.component";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { debug } from "console";

export const SSRSReport = ({ reporte }: any) => {
  const [openfilter, setOpenFilter] = useState<boolean>(false);
  const [complementoUrl, setComplementoUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<number>(1);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [filterValues, setFilterValues] = useState<any>({});
  const [viewMode, setViewMode] = useState<string>("Normal");

  const { bannerCatalog, titleReport } = useSelector(
    (state: any) => state.theme,
  );
  const size: Size = useWindowSize();
  const orientation: Orientation = useOrientation();

  /* VIEW MODE */
  useEffect(() => {
    if (orientation.orientation === 90) {
      setViewMode("MobileLandscape");
      return;
    }

    if (size.width && size.width < 800) {
      setViewMode("MobilePortrait");
      return;
    }

    setViewMode("Normal");
  }, [orientation, size]);

  /* INIT FILTERS */
  useEffect(() => {
    let localParamaters = reporte?.parameters || [];

    if (localParamaters.length > 0) {
      let oParams: any = {};
      setOpenFilter(true);
      for (const parameter of localParamaters) {
        if (parameter.values.length > 0 && parameter.visible === true) {
          let aFilter: Array<Values> = parameter.values.filter(
            (item: Values) => item.valorPredeterminado === 1,
          );

          if (aFilter.length > 0) {
            let aAplyFilter: Array<any> = [];
            let oFilter: any = {};

            for (const filter of aFilter) {
              if (parameter.tipoParametro === "Combo") {
                aAplyFilter.push({
                  value: filter.value,
                  label: filter.label,
                });
              }

              if (parameter.tipoParametro === "ComboSencillo") {
                oFilter = filter;
              }

              if (parameter.tipoParametro === "Fecha") {
                oFilter = filter.value;
              }
            }

            oParams[parameter.codigoParametro] =
              parameter.tipoParametro === "Combo" ? aAplyFilter : oFilter;
          }
        }
      }

      setFilterValues(oParams);
    }
  }, [reporte]);

  /* LOADING FLOW */
  useEffect(() => {
    if (isLoading === 2) {
      const timer = setTimeout(() => setIsLoading(3), 4000);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  const buildUrl = (paramets: string): string => {
    debugger;
    const urlPath = configApp.url_reporte?.includes("?")
      ? configApp.url_reporte
      : `${configApp.url_reporte}?`;

    const paramsClean = paramets.endsWith("&")
      ? paramets.slice(0, -1)
      : paramets;
    return `${urlPath}Rpt=${reporte.url}&${paramsClean}`;
  };

  return (
    <Layout
      theme={{
        backgroundImage: "none",
        backgroundColor: "#f5f7f7",
      }}
    >
      <Head bg={bannerCatalog}>
        {[1, 2, 3].includes(isLoading) && (
          <>
            <IconButton
              onClick={() => setOpenFilter(!openfilter)}
              style={{ color: "white" }}
            >
              {openfilter ? <CloseIcon /> : <FilterAltIcon />}
            </IconButton>

            <span
              className={titleReport ? "title-report" : "title-report-city"}
            >
              {reporte.parent} {reporte.name}
            </span>
          </>
        )}
      </Head>

      {complementoUrl.length > 0 && (
        <IframeContainer
          src={buildUrl(complementoUrl)}
          display={isLoading === 3 ? "flex" : "none"}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-top-navigation"
          allow="fullscreen"
        />
      )}

      {openfilter && (
        <FilterComponent
          filterName={reporte.name}
          parameters={reporte.parameters}
          setValues={setFilterValues}
          type="SSRS"
          filterValues={filterValues}
          handleViewReport={(parameter: string) => {
            setComplementoUrl(parameter);
            setOpenFilter(false);
            setIsLoading(2);
          }}
        />
      )}
    </Layout>
  );
};
